import { NextAkceloAdArea } from '../NextAkceloService/NextAkceloAdArea';
import { NextGooglePublisherTagAdArea } from '../NextGooglePublisherTagService/NextGooglePublisherTagAdArea';
import { NextOptiDigitalAdArea } from '../NextOptiDigitalService/NextOptiDigitalAdArea';

interface NextAdAreaProps {
  optiDigitalAreaId?: string;
  akceloSlotId?: string;
  akceloAdUnitClass?: string;
  akceloDesktopHeight?: number;
  akceloMobileHeight?: number;
  withGooglePublisherTag?: boolean;
  googlePublisherTagSlotId?: string;
}

declare global {
  interface Window {
    __isPremiumUser?: boolean;
  }
}

const isPremiumClient = (): boolean =>
  typeof window !== 'undefined' && window.__isPremiumUser === true;

export const NextAdArea = ({
  optiDigitalAreaId,
  akceloSlotId,
  akceloAdUnitClass,
  akceloDesktopHeight,
  akceloMobileHeight,
  withGooglePublisherTag = false,
  googlePublisherTagSlotId,
}: NextAdAreaProps) => {
  if (isPremiumClient()) {
    return null;
  }

  return (
    <>
      {akceloSlotId && akceloAdUnitClass ? (
        <NextAkceloAdArea
          slotId={akceloSlotId}
          adUnitClass={akceloAdUnitClass}
          desktopHeight={akceloDesktopHeight}
          mobileHeight={akceloMobileHeight}
        />
      ) : null}
      {withGooglePublisherTag ? (
        <NextGooglePublisherTagAdArea slotId={googlePublisherTagSlotId} />
      ) : null}
      {optiDigitalAreaId ? (
        <NextOptiDigitalAdArea areaId={optiDigitalAreaId} />
      ) : null}
    </>
  );
};
